import React from 'react';
import img from '../../assets/img/img-teleconsultas.png'
const TeleconsultasPage = () => {
return(
  <section>
      <div className="container">
          <div className="row pt-5 pb-5">
              <div className="col-lg-8">
                  <div className="global_title">
                      Teleconsultas
                  </div>
                  <hr className="hr6"/>
                  <div className="contenido">
                      <p>
                      <strong>What is Lorem Ipsum?</strong>
                      <br/>
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                      </p>
                  </div>
              </div>
              <div className="col-lg-4">
                  <img src={img} alt="..." className="img-fluid"/>
              </div>
          </div>
      </div>
  </section>
);
}
export default TeleconsultasPage;